// frontend-web/src/pages/Admin/ViewQuestions.jsx

import React, { useEffect, useState } from "react";
import api from "../../api";
import { useNavigate } from "react-router-dom";

export default function ViewQuestions() {
  const navigate = useNavigate();

  const [classes, setClasses] = useState([]);
  const [subjects, setSubjects] = useState([]);
  const [questions, setQuestions] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSubject, setSelectedSubject] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadClasses();
  }, []);

  const loadClasses = async () => {
    try {
      const res = await api.get("https://api.eduat10.com/api/admin/classes");
      setClasses(res.data);
    } catch {
      alert("❌ Failed to load classes");
    }
  };

  const loadSubjects = async (classId) => {
    setLoading(true);
    try {
      const res = await api.get(`/admin/subjects/${classId}`);
      setSubjects(res.data);
      setSelectedSubject("");
      setQuestions([]);
    } catch {
      alert("❌ Failed to load subjects");
    } finally {
      setLoading(false);
    }
  };

  const loadQuestions = async (classId, subjectId) => {
    if (!classId || !subjectId) return;

    setLoading(true);
    try {
      const res = await api.get(
        `/admin/questions?class_id=${classId}&subject_id=${subjectId}`
      );

      setQuestions(res.data.questions || res.data.data || res.data || []);
    } catch {
      alert("❌ Failed to load questions");
      setQuestions([]);
    } finally {
      setLoading(false);
    }
  };

  const deleteQuestion = async (id) => {
    if (!window.confirm("Are you sure you want to delete this question permanently?")) return;

    try {
      await api.delete(`/admin/questions/${id}`);
      alert("🗑 Question deleted successfully!");
      loadQuestions(selectedClass, selectedSubject);
    } catch {
      alert("❌ Failed to delete question");
    }
  };

  const selectedClassName = classes.find(c => c.id === selectedClass)?.name || "";
  const selectedSubjectName = subjects.find(s => s.id === selectedSubject)?.name || "";

  return (
    <div style={pageStyle}>
      <div style={headerStyle}>
        <button onClick={() => navigate(-1)} style={backBtn}>Back to Dashboard</button>
        <h1 style={{ margin: 0 }}>View Questions</h1>
        <div style={{ width: "120px" }}></div>
      </div>

      <div style={containerStyle}>
        <div style={sectionStyle}>
          <h3 style={sectionTitle}>Select Class</h3>
          <div style={tabContainer}>
            {classes.map((cls) => (
              <button
                key={cls.id}
                onClick={() => {
                  setSelectedClass(cls.id);
                  loadSubjects(cls.id);
                  setQuestions([]);
                }}
                style={{
                  ...classTab,
                  backgroundColor: selectedClass === cls.id ? "#3b82f6" : "#f1f5f9",
                  color: selectedClass === cls.id ? "white" : "#334155",
                }}
              >
                {cls.name}
              </button>
            ))}
          </div>
        </div>

        {selectedClass && (
          <div style={sectionStyle}>
            <h3 style={sectionTitle}>Select Subject</h3>

            {loading && subjects.length === 0 ? (
              <p>⏳ Loading subjects...</p>
            ) : (
              <div style={tabContainer}>
                {subjects.map((sub) => (
                  <button
                    key={sub.id}
                    onClick={() => {
                      setSelectedSubject(sub.id);
                      loadQuestions(selectedClass, sub.id);
                    }}
                    style={{
                      ...subjectTab,
                      backgroundColor: selectedSubject === sub.id ? "#10b981" : "#f1f5f9",
                      color: selectedSubject === sub.id ? "white" : "#334155",
                    }}
                  >
                    {sub.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}

        {selectedClass && selectedSubject && (
          <div style={breadcrumbStyle}>
            <strong>{selectedClassName}</strong> →{" "}
            <strong>{selectedSubjectName}</strong>
            <span style={{ marginLeft: 10 }}>({questions.length} Questions)</span>
          </div>
        )}

        {selectedSubject && (
          <div style={tableContainer}>
            {loading ? (
              <div style={loadingBox}>⏳ Loading questions...</div>
            ) : questions.length === 0 ? (
              <div style={emptyBox}>⚠ No questions found.</div>
            ) : (
              <div style={{ overflowX: "auto" }}>
                <table style={tableStyle}>
                  <thead>
                    <tr style={theadRow}>
                      <th>#</th>
                      <th>Question</th>
                      <th>A</th>
                      <th>B</th>
                      <th>C</th>
                      <th>D</th>
                      <th>Correct</th>
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <tbody>
                    {questions.map((q, i) => (
                      <tr key={q.id}>
                        <td>{i + 1}</td>
                        <td style={{ textAlign: "left", maxWidth: "320px" }}>{q.text}</td>
                        <td>{q.option_a}</td>
                        <td>{q.option_b}</td>
                        <td>{q.option_c}</td>
                        <td>{q.option_d}</td>
                        <td style={{ fontWeight: "bold", color: "#16a34a" }}>
                          {q.correct?.toUpperCase()}
                        </td>
                        <td>
                          {/* 🔥 FIXED PATH */}
                          <button
                            style={editBtn}
                            onClick={() => navigate(`/admin/question/edit/${q.id}`)}
                          >
                            ✏ Edit
                          </button>

                          <button style={deleteBtn} onClick={() => deleteQuestion(q.id)}>
                            🗑 Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>

                </table>
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
}


const pageStyle = { fontFamily: "Inter, sans-serif", background: "#f8fafc", minHeight: "100vh" };
const headerStyle = { background: "white", padding: "20px 30px", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.1)", margin: "20px" };
const backBtn = { padding: "12px", background: "#6b7280", color: "white", borderRadius: "8px", border: "none", cursor: "pointer" };

const containerStyle = { maxWidth: "1400px", margin: "auto", padding: "20px" };
const sectionStyle = { background: "white", padding: "20px", marginBottom: "20px", borderRadius: "12px", boxShadow: "0 4px 20px rgba(0,0,0,0.08)" };
const sectionTitle = { marginBottom: "15px", fontWeight: "bold" };

const tabContainer = { display: "flex", gap: "10px", flexWrap: "wrap" };
const classTab = { padding: "12px 20px", borderRadius: "10px", border: "1px solid #ccc", cursor: "pointer" };
const subjectTab = { padding: "10px 18px", borderRadius: "10px", border: "1px solid #ccc", cursor: "pointer" };

const breadcrumbStyle = { padding: "15px", background: "#ecfdf5", borderRadius: "10px", fontSize: "18px", marginBottom: "15px" };

const tableContainer = { background: "white", borderRadius: "12px", overflow: "hidden" };
const tableStyle = { width: "100%", borderCollapse: "collapse" };
const theadRow = { background: "#1e40af", color: "white" };

const editBtn = { padding: "6px 14px", background: "#f59e0b", color: "white", borderRadius: "8px", border: "none", cursor: "pointer", marginRight: "6px" };
const deleteBtn = { padding: "6px 14px", background: "#ef4444", color: "white", borderRadius: "8px", border: "none", cursor: "pointer" };

const loadingBox = { padding: "50px", textAlign: "center" };
const emptyBox = { padding: "40px", textAlign: "center", color: "#64748b" };
